import {React} from '@api'
import {Icon, IconName} from '@blueprintjs/core'
import {Collections, Dashboard, DesktopMacOutlined, InsertPhoto, ListAltOutlined, LocalLibrary, Palette, PresentToAll, EventNote, OpenInNew, FlagOutlined} from '@material-ui/icons'
import {CentricLogo} from '@stores/ui/CentricLogo'
import {AddIcon, AddManyIcon, PdfSvgIcon} from '@stores/ui/customIcons'

type VipIconKey = 'relationships' | 'usedBy' | 'refersTo' | 'presets' | 'add' | 'addMany' | 'addFromImage' | 'addFromImages'
  | 'pdf' | 'goToSeason' | 'active' | 'inactive' | 'changeGroup' | 'publish' | 'sidebar' | 'modal' | 'reportView' | 'manageHierarchy' | 'c8' | 'openLeftSidebar'
  | 'closeLeftSidebar' | 'dev' | 'manageFields' | 'groupBy' | 'groupByH1' | 'groupByH2' | 'search' | 'reset'
  | 'filter' | 'sort' | 'clear' | 'clearHierarchy' | 'previewCard' | 'blank' | 'card' | 'table'
  | 'cardFieldLabels' | 'inlineDetails' | 'targetsToolbar' | 'arrowRight' | 'arrowUp' | 'switchDetailViewLocation' | 'catalog' | 'catalogLibrary' | 'library' | 'aggregateDetails' | 'workspace' | 'collapse'
  | 'expand' | 'collapseAll' | 'expandAll' | 'duplicate' | 'chooseSwatches' | 'heroCards' | 'showExpandedFirst' | 'showOnlyExpanded' | 'toggleCardSwatches' | 'columnView' | 'showEmptyGroups' | 'hideEmptyGroups'
  | 'nestedFields' | 'fieldLabels' | 'flexLayout' | 'restore' | 'maximize' | 'assortmentLayout' | 'info' | 'changeHistory' | 'changeLog' | 'openInNew' | 'smsOption' | 'whiteboard'

export const icons: Record<VipIconKey, IconName | JSX.Element> = {
  relationships: 'flows',
  usedBy: 'fork',
  refersTo: 'book',

  presets: 'mugshot',
  add: <AddIcon/>,
  addMany: <AddManyIcon/>,
  addFromImage: <InsertPhoto/>,
  addFromImages: <Collections/>,
  pdf: <PdfSvgIcon/>,

  goToSeason: 'calendar',
  active: 'tick-circle',
  inactive: 'ban-circle',

  changeGroup: 'changes',
  publish: 'cloud-upload',
  sidebar: 'drawer-left-filled',
  modal: 'modal',
  reportView: 'git-repo',

  manageHierarchy: 'layout-hierarchy',
  c8: <CentricLogo/>,
  openLeftSidebar: 'drawer-left-filled',
  closeLeftSidebar: 'drawer-right',

  dev: 'lightbulb',
  manageFields: 'properties',

  groupBy: 'diagram-tree',
  groupByH1: 'header-one',
  groupByH2: 'header-two',
  search: 'search-text',
  reset: 'clean',
  filter: 'filter',
  sort: 'sort',
  clear: 'clean',
  clearHierarchy: 'clean',

  previewCard: <ListAltOutlined/>,
  blank: 'blank',
  card: 'cube', //'mugshot',
  table: 'grid',
  cardFieldLabels: 'label',
  inlineDetails: 'list-detail-view',
  targetsToolbar: 'dollar',
  arrowRight: 'arrow-right',
  arrowUp: 'arrow-up',

  switchDetailViewLocation: 'panel-stats',

  catalog: 'application',
  catalogLibrary: <LocalLibrary/>,
  library: 'list-detail-view',
  aggregateDetails: 'grouped-bar-chart',
  workspace: <DesktopMacOutlined/>,

  collapse: 'chevron-up',
  expand: 'chevron-down',
  collapseAll: 'double-chevron-up',
  expandAll: 'double-chevron-down',

  duplicate: 'layers',
  chooseSwatches: <Palette/>,
  heroCards: <Dashboard/>,

  showExpandedFirst: <Icon icon='pin'/>,
  showOnlyExpanded: <Icon icon='segmented-control'/>,
  toggleCardSwatches: 'comparison',
  columnView: <Icon icon='two-columns'/>,
  showEmptyGroups: <Icon icon='eye-open'/>,
  hideEmptyGroups: <Icon icon='eye-off'/>,

  nestedFields: 'properties',
  fieldLabels: 'label',
  flexLayout: 'page-layout',

  restore: 'minimize',
  maximize: 'maximize',
  assortmentLayout: 'grid-view',
  info: 'info-sign',
  changeHistory: 'delta',
  changeLog: <EventNote/>,
  openInNew: <OpenInNew/>,
  smsOption: <FlagOutlined/>,
  whiteboard: <PresentToAll/>
}



// WEBPACK FOOTER //
// ./src/stores/ui/centricIcons.tsx